<template>
  <div>
    <title>销售单管理</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <!-- <header class="tabHeader">
        <p>
          <router-link :to="{name:'销售单管理'}" class="isActive">销售单管理</router-link>
          <router-link :to="{name:'历史发货记录'}" v-if="userInfoMd&& (!userInfoMd.isopenfinancial || userInfoMd.isopensale)">历史发货记录</router-link>
          <router-link :to="{name:'商品SKU列表'}">商品SKU列表</router-link>
        </p>
      </header> -->
      <CompanyTab :active="currentTit"></CompanyTab>
      <!--E 头部tab-->

      <!--S 销售单列表-->
      <SaleOrderList :saleOrderType="0"></SaleOrderList>
      <!--E 销售单列表-->
    </section>
  </div>
</template>
<script>
export default {
  name: "SalesOrderManage",
  data() {
    return {
      currentTit:0,
      userInfoMd: '', //登录信息
    };
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    SaleOrderList: resolve =>
      require(["@/components/OrderFolder/StoreSale/SaleOrderList.vue"], resolve) //销售单列表组件
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {
    if(localStorage.getItem('userInfoMd') && localStorage.getItem("userInfoMd") != 'null' && localStorage.getItem("userInfoMd") != undefined){
      this.userInfoMd = JSON.parse(localStorage.getItem("userInfoMd"));
    }
  }
};
</script>

<style scoped>
.mainPart {
  padding: 20px;
  height: calc(100% - 50px);
}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/SalesOrderManage.vue